import React from 'react'
import {
  Modal,
  ModalBody,
  ModalHead,
  ModalFoot,
  MODAL_SIZE_LG,
  Flex
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'
import TableMessages from './components/TableMessages'
import Search from './components/Search'
import HeaderMessageBox from './components/HeaderMessageBox'
import ErrorFeedback from 'Components/ErrorFeedback'
import useModalEmailMessages from 'Hooks/useModalEmailMessages/useModalEmailMessages'

const ModalEmailMessages = ({
  handleCancel,
  handleConfirm,
  showMessageBox
}) => {
  const intl = useIntl()
  const { show, loaded, error, errMessage, severity } = useModalEmailMessages()

  return (
    <>
      <Modal
        data-mu-test='modal-email-messages'
        show={show}
        showClose
        onClose={handleCancel}
        closeOnOverlayClick
        size={MODAL_SIZE_LG}
      >
        <ModalHead
          title={intl.formatMessage({
            id: 'Load.SelectEmailMessage.Title'
          })}
        />
        <ModalBody scrollable>
          <Flex maxHeight='500px' flexDirection='column' rowGap='24px'>
            <ErrorFeedback error={errMessage} severity={severity} />
            {!error && loaded && (
              <>
                {showMessageBox && <HeaderMessageBox />}
                <Search />
                <TableMessages handleConfirm={handleConfirm} />
              </>
            )}
          </Flex>
        </ModalBody>
        <ModalFoot />
      </Modal>
    </>
  )
}

ModalEmailMessages.defaultProps = {
  showMessageBox: false
}

ModalEmailMessages.propTypes = {
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func,
  showMessageBox: PropTypes.bool
}

export default ModalEmailMessages
